<template>
  <v-container
    fluid
    class="main-container">
    <div class="px-4">
      <v-row>
        <v-toolbar
          flat
          color="transparent">
          <v-spacer></v-spacer>
          <v-toolbar-title class="score-title pl-4 text-uppercase">Finance</v-toolbar-title>
          <v-btn
            class="pr-0"
            style="margin-right: -12px; margin-bottom: -8px"
            text
            to="career">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid lightgrey"
            height="420">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ 이벤트 목적자금 우선순위</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              dense
              class="listing">
              <v-list-item
                v-for="(m, i) in getFinanceGoalMoney"
                :key="m.title"
                style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle style="flex-basis: 80%">
                  {{ `${i + 1}순위 -` }}
                  <span class="font-weight-bold blue--text lighten-3">{{ m.title }}</span>
                </v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ `${m.money} 백만원 - (${m.age}세 까지)` }}</v-list-item-title>
              </v-list-item>
              <v-list-item></v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid lightgrey"
            height="420">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ 2nd Life Risk 보장</div>
            </v-card-title>
            <v-list
              dense
              class="listing">
              <v-list-item
                v-for="(m, i) in finance['재무-리스크'].value"
                :key="m.title"
                style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>
                  {{ `${i + 1}순위 -` }}
                  <span class="font-weight-bold blue--text lighten-3">{{ m.text.split(/\s/g)[0] }}</span>
                </v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ m.value ? '가입' : '미가입' }}</v-list-item-title>
              </v-list-item>
              <v-list-item></v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="5">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid lightgrey"
            height="420">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ 생애 이슈</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              dense
              class="listing">
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>은퇴 크레바스 구간은?</v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ crevasseAge }}</v-list-item-title>
              </v-list-item>
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>크레바스 구간 조정가능 대안은?</v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ (this.finance['재무-음수구간대안'] || {}).value || '' }}</v-list-item-title>
              </v-list-item>
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>퇴직후 가능 근로소득은?</v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ ((this.finance['재무-기대근로소득'] || {}).value || [])[0].value || 0 }} 만원</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-subtitle>목적자금 1,2 달성시기는?</v-list-item-subtitle>
                <v-list-item-title class="text-right">
                  {{ `${getSourcingMoney[0][0]}` }}
                  <span class="subtitle-2">{{ `(~${getSourcingMoney[0][1]})` }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle></v-list-item-subtitle>
                <v-list-item-title class="text-right">
                  {{ `${getSourcingMoney[1][0]}` }}
                  <span class="subtitle-2">{{ `(~${getSourcingMoney[1][1]})` }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>2nd life Risk 부족한 보장은?</v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ getInsurance }}</v-list-item-title>
              </v-list-item>
              <v-list-item style="border-bottom: 1px solid lightGrey">
                <v-list-item-subtitle>기타 재무이슈는?</v-list-item-subtitle>
                <v-list-item-title class="text-right">{{ (this.finance['재무-재무이슈'] || {}).value || '' }}</v-list-item-title>
              </v-list-item>
              <v-list-item></v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  components: {},
  mounted() {
    // console.log(this.housePension)
  },
  data() {
    return {
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'exit']),
    cellLength() {
      const nintyAt = this.me.birthAt + 91
      // console.log(nintyAt, this.currentYear)
      return nintyAt - this.currentYear
      // return 40
    },
    crevasseAge() {
      const t = (this.exit[17] || []).slice(0)

      if (!t[0]) return '없음'
      else {
        const s = t.shift()
        const e = t.pop()

        if (!e) return '없음'
        else return s + '세부터 ' + e + '세까지'
      }
    },
    getInsurance() {
      const k = ((this.finance['재무-리스크'] || {}).value || []).filter((o) => !o.value)
      if (k.length === 0) return '없음'
      else return k.map((o) => o.text.split(/\s/g)[0]).join(',')
    },
    getSourcingMoney() {
      const t = _.orderBy(this.finance['재무-목적자금-우선순위'].list, ['order'], ['asc'])

      const e1 = t.shift().title
      const e2 = t.shift().title

      const k = this.finance['재무-목적자금-계획'].value

      const ep1 = Number(k.filter((o) => o.title === e1)[0].value[1]) > 0 ? Number(k.filter((o) => o.title === e1)[0].value[1]) + this.me.birthAt : '입력안함'
      const ep2 = Number(k.filter((o) => o.title === e2)[0].value[1]) > 0 ? Number(k.filter((o) => o.title === e2)[0].value[1]) + this.me.birthAt : '입력안함'

      return [
        [e1, ep1],
        [e2, ep2],
      ]
    },
  },
  methods: {
    getExample() {
      // this.setExample()
    },
  },
}
</script>

<style
  scoped
  lang="scss">
.listing div.v-list-item__subtitle {
  font-size: 16px !important;
}
.listing div.v-list-item__title {
  font-size: 18px !important;
}
.listing div.v-list-item > div {
  line-height: 18px !important;
}
table.contents {
  width: 100%;
}
.bottom-border {
  border-bottom: 1px solid grey;
}
table.tbl {
  border-collapse: collapse !important;
  table-layout: fixed;
  font-size: 12px;

  thead tr {
    height: 30px;
    font-weight: bold;
    font-size: 18px;
  }
  tr:nth-of-type(2n) {
    // background: #f7cac9;
  }
  tr.age-row > td {
    font-size: 12px !important;
    font-weight: 600;
    height: 25px;
    line-height: 25px;
  }
  div.content-cell {
    line-height: 25px;
    background: #70cae9;
    color: white;
    width: 100%;
    height: 25px;
  }
  div.content-border {
    border-radius: 25px 25px 25px 25px;
  }

  div.pension-start {
    border-radius: 5px 45% 45% 5px;
  }
  td div.start-row {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  td div.end-row {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  tr.exit-row {
    height: 20px;
    font-size: 12px;
    font-weight: 600;

    td div {
      line-height: 20px;
      background: grey;
      color: white;
      width: 100%;
      height: 20px;
    }

    div.col-header {
      text-align: left;
      width: 90%;
      border-radius: 0 25px 25px 0;
      background: grey;
      color: white;
    }
  }
  th,
  td :not(.title-cell) {
    white-space: nowrap;
    word-break: break-all;
    // border: 1px solid grey;
  }
  td.title-cell {
    overflow-wrap: break-word;
  }
  th.event,
  td.event {
    // border-left: 2px solid #9b1b30; //#9b1b30;
    // font-weight: 600;
    // color: white; #2a4b7c; //
    background-color: rgba(42, 75, 124, 0.6) !important;
    div {
      background-color: rgba(42, 75, 124, 0.6) !important;
    }
  }

  .title-cell {
    min-width: 90px !important;
    // width: 4%;
    width: 95px;

    // background-color: #2a4b7c;
    // color: white;
  }
  td.minus {
    font-weight: 600;
    color: #9b1b30;
  }
}
.score {
  padding: 18px;
}
.life-top {
  font-size: 1em;
  border-bottom: 2px solid black;
}
.header-col {
  border-right: 1px solid black;
}
.life {
  text-align: center;
  min-height: 64px;
}
.life-footer {
}
// .echarts {
//   width: 100%;
//   height: 100%;
// }
.echarts {
  height: 400px;
  width: 100%;
}
.good {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.bad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.happy-row {
  border-top: 1px solid grey;
}
</style>
